const NAME_DELIM = /[\u200B]+/;

export function createDefaultPassword(name: string, date: Date): string {
  const parts = name.split(NAME_DELIM);

  const takeThree = (s: string | undefined): string => {
    const trimmed = (s ?? '').trim();
    return trimmed.length <= 3 ? trimmed : trimmed.slice(0, 3);
  };

  const firstNameThreeLetters = takeThree(parts[0]);
  const lastNameThreeLetters = takeThree(parts[1]);

  // Dùng UTC để khớp TimeZone GMT của SimpleDateFormat bên Android
  const accountCreationYear = String(date.getUTCFullYear()); // "yyyy"
  const accountCreationDate = String(date.getUTCDate()); // "d" (1-31, không leading zero)

  return firstNameThreeLetters + accountCreationYear + lastNameThreeLetters + accountCreationDate;
}
